// extracted by mini-css-extract-plugin
export var addViewLink = "_1a-1";
export var availabilityIcon = "_1a-16";
export var availabilitySelectionIcon = "_1a-15";
export var backButton = "_1a-2";
export var backIcon = "_1a-z";
export var conversationCount = "_1a-3";
export var dragHandle = "_1a-5";
export var dropdown = "_1a-e";
export var dropdownIcon = "_1a-7";
export var dropdownOption = "_1a-6";
export var dropdownTriangle = "_1a-d";
export var expand = "_1a-f";
export var folder = "_1a-i";
export var folderItem = "_1a-c";
export var icon = "_1a-8";
export var iconRow = "_1a-9";
export var image = "_1a-a";
export var logo = "_1a-b";
export var navContainer = "_1a-h";
export var navigationFooter = "_1a-g";
export var pageShell = "_1a-0";
export var placeholderAvailable = "_1a-11";
export var placeholderBox = "_1a-14";
export var placeholderBusy = "_1a-13";
export var placeholderUnavailable = "_1a-12";
export var profile = "_1a-k";
export var profileContainer = "_1a-m";
export var profileDropdown = "_1a-n";
export var profileImage = "_1a-l";
export var profileMain = "_1a-o";
export var profileSubtitle = "_1a-q";
export var profileTitle = "_1a-p";
export var reorderIcon = "_1a-r";
export var sentLine = "_1a-u";
export var settingsHeader = "_1a-s";
export var sidenavTextColor = "_1a-y";
export var spamLine = "_1a-t";
export var subitemWithTag = "_1a-4";
export var supportItems = "_1a-j";
export var teamText = "_1a-10";
export var viewLine = "_1a-x";
export var viewLineButton = "_1a-w";
export var viewLineButtons = "_1a-v";